import { FC } from 'react';
import ProForm, { FormProps, useForm } from './form';
import ProFormItem, { FormItemProps } from './item';
import ProFormList, { FormListProps } from './list';
import ProFormErrorList, { ErrorListProps } from './errorList';
import { FormInstance as FormInstanceCopy } from 'antd/lib/form/hooks/useForm';

export type FormInstance = FormInstanceCopy;
export type IFormComponent = FC<
  FormProps & React.RefAttributes<HTMLElement>
> & {
  useForm: typeof useForm;
  Item: FC<FormItemProps>;
  List: FC<FormListProps>;
  ErrorList: FC<ErrorListProps>;
};

const TransForm = ProForm as IFormComponent;
TransForm.useForm = useForm;
TransForm.Item = ProFormItem;
TransForm.List = ProFormList;
TransForm.ErrorList = ProFormErrorList;

export default TransForm;
